import React from 'react';
import PropTypes, { any } from 'prop-types';
import { useDispatch } from 'react-redux';
import { Form } from 'react-form';

import {
    Textarea,
} from '../../Form';

import Popup from '../../Popup';
import { createWeatherNotification, updateWeatherNotification } from '../../../actions/event-profile-actions';

import styles from './addWeatherUpdatePopup.scss';

const AddWeatherUpdatePopup = (props) => {
    const {
        event,
        onCloseClick,
        weatherNotification,
    } = props;

    const dispatch = useDispatch();

    const handleSubmit = async ({ values }) => {
        if (values.notificationText) {
            if (weatherNotification) {
                dispatch(updateWeatherNotification(event.id, weatherNotification.id, values.notificationText));
            } else {
                dispatch(createWeatherNotification(event.id, values.notificationText));
            }
        }
        onCloseClick();
    };

    const defaultValues = {
        notificationText: weatherNotification?.notificationText || '',
    };

    return (
        <Popup
            className={`popup-md ${styles.addWeatherUpdatePopup}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: false,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
                noHeader: true,
            }}
        >
            <Form onSubmit={values => handleSubmit({ values })} defaultValues={defaultValues}>
                {(formApi) => {
                    const { submitForm, submitting, values } = formApi;
                    const isTextEmpty = !values.notificationText?.trim();

                    return (
                        <form onSubmit={submitForm} id="weatherUpdateForm" data-test="weatherUpdateForm" data-testid="modal.weather.form-57">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12">
                                        <h5 className={styles.title} data-testid="modal.weather.h5-61">
                                            {weatherNotification ? 'Edit weather update' : 'Add weather update'}
                                        </h5>
                                    </div>
                                    <div className="col-12">
                                        <h6 className={styles.subTitle} data-testid="modal.weather.h6-66">
                                            Date and time stamp will be added.
                                        </h6>
                                    </div>
                                    <div className="col-12 mt16">
                                        <Textarea
                                            className={styles.textArea}
                                            id="notificationText"
                                            field="notificationText"
                                            rows="5"
                                            data-testid="addweatherupdatepopup.notification-text-textarea"
                                        />
                                    </div>
                                    <div className="col-12 d-flex align-items-center mt16">
                                        <input
                                            type="checkbox"
                                            className={`${styles.customCheckbox} me-2 mr8`}
                                        />
                                        <label htmlFor="notifyPlayers" className="m-0 text-dark" data-testid="modal.weather.label-85">Notify players</label>
                                    </div>
                                </div>
                                <div className="row mt16">
                                    <div className="col-12 d-flex justify-content-between gap-2">
                                        <button
                                            onClick={onCloseClick}
                                            type="button"
                                            className={`btn btn-default btn-xl text-uppercase ${styles.popupButton}`}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className={`btn btn-primary btn-xl text-uppercase ${styles.popupButton} ${styles.btnText}`}
                                            disabled={submitting || isTextEmpty}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </Popup>
    );
};

export default AddWeatherUpdatePopup;

AddWeatherUpdatePopup.propTypes = {
    event: PropTypes.objectOf(any).isRequired,
    onCloseClick: PropTypes.func.isRequired,
    weatherNotification: PropTypes.shape({
        id: PropTypes.string.isRequired,
        notificationText: PropTypes.string.isRequired,
    }),
};

AddWeatherUpdatePopup.defaultProps = {
    weatherNotification: null,
};
